<template>
  <section :class="['section', 'child-view', 'section--expertise', 'section--expertise-child', 'section--expertise-interact']">
    <div class="wrapper" :class="{ 'with-modal': isModalVisible}">
      <div class="content">
        <div class="heading">
          <div class="back-btn">
            <router-link
              :to="`/expertise`">
            </router-link>
            <span>back</span>
          </div>
        </div>
        <div class="expertise-holder">
          <ul class="parts-number">
            <li class="number-3">
              <span class="number">/3</span>
              <span class="text">AR, VR, 3D, Unity</span>
              <ul class="list-tools">
                <li>
                  <img src="../assets/images/programs_icons/blender.svg" alt="blender">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/adobe_animate.svg" alt="adobe animate">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/cinema4d.svg" alt="cinema4d">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/autodesk_maya.svg" alt="autodesk maya">
                </li>
                <li>
                  <img src="../assets/images/programs_icons/unity.svg" alt="unity">
                </li>
              </ul>
            </li>
          </ul>
          <div class="expertise-container">
            <span class="circle-title">Interact</span>
            <div class="circle-holder">
              <ul class="circle-block">
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('unity')">
                    <span class="text">Unity</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('ar')">
                    <span class="text">AR</span>
                  </div>
                </li>
                <li class="circle-button size-3">
                  <div class="text-holder"
                    @click="openModal('conversational-ui')">
                    <span class="text">Conversational UI</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('vr')">
                    <span class="text">VR</span>
                  </div>
                </li>
                <li class="circle-button size-2">
                  <div class="text-holder"
                    @click="openModal('3d')">
                    <span class="text">3D</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div><!--end content-->
    </div>
    <window-modal v-show="isModalVisible" v-model="modalData[activeItem]" @close="closeModal"></window-modal>
  </section>
</template>

<script>
import Footer from '@/components/UI/Footer';
import { mapActions } from 'vuex';
import WindowModal from '@/components/modals/WindowModal.vue';

export default {
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  data() {
    return {
      isModalVisible: false,
      activeItem: 'unity',
      modalData: {
        unity: {
          title: 'Unity',
          content: 'We use of the Unity Game Engine as a versatile tool for creating interactive and immersive design experiences, especially in the fields of game design, architectural visualization, and virtual reality. Designers leverage Unity\'s capabilities to build and prototype interactive 3D environments, simulations, and applications, enabling them to explore and communicate their ideas in dynamic and engaging ways.',
          linkUrl: 'https://google.com',
          sizeClass: 'size-2',
          positionClass: 'down-position',
        },
        ar: {
          title: 'AR',
          content: 'Augmented Reality, involves the use of AR technology to overlay digital design elements or prototypes onto the physical world, enabling users to visualize and evaluate how their designs will interact with the real environment. It offers a unique perspective for assessing spatial relationships, user interactions, and contextual factors, ultimately enhancing the design process and user experience.',
          linkUrl: 'https://google.com',
          sizeClass: 'size-2',
        },
        'conversational-ui': {
          title: 'Conversational UI',
          content: 'Conversational UI in design pertains to the user interface and interaction design for chatbots, virtual assistants, and other conversational interfaces. It focuses on creating intuitive and effective interactions through natural language conversations, allowing users to interact with digital systems in a more conversational and user-friendly manner.',
          linkUrl: 'https://google.com',
          sizeClass: 'size-3',
        },
        vr: {
          title: 'VR',
          content: 'Virtual Reality, in design refers to the use of immersive virtual environments to create, visualize, and evaluate design concepts, products, or spaces. It allows designers to step into a simulated 3D world, enabling them to assess scale, proportion, and user experiences in a more realistic and interactive manner, leading to more informed and effective design decisions.',
          linkUrl: 'https://google.com',
          sizeClass: 'size-2',
        },
        '3d': {
          title: '3D',
          content: '3D in design involves the utilization of three-dimensional space and objects to create visual or physical representations of products, spaces, or concepts. It allows designers to add depth, realism, and interactive elements to their designs, enhancing their ability to convey ideas and engage with users or stakeholders.',
          linkUrl: 'https://google.com',
          sizeClass: 'size-2',
          positionClass: 'down-position',
        },
      },
    };
  },
  methods: {
    ...mapActions({ fetchExpertisePageContent: '/expertise/expertise:fetch' }),
    openModal(activeItemName) {
      this.activeItem = activeItemName;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    },
  },
  components: {
    Footer,
    WindowModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ExpertiseInteract.vue